import React from 'react';

function WhatIsRepoPromptContent() {
  return (
    <>
      <h3>What is Repo Prompt?</h3>

      <p>Repo Prompt is a versatile tool designed for anyone who needs to efficiently extract insights from files and data using AI. While especially beneficial for developers and programmers working with codebases, it's equally valuable for researchers, academics, students, writers, data analysts—anyone dealing with lots of text!</p>
      
      <p>At its core, Repo Prompt addresses the challenge of context: it organizes and structures the exact information your AI needs from your files, eliminating the mess of manual copy-pasting and unnecessary information sharing. It also makes it trivial to create and edit files at scale.</p>
      
      <p>For developers, Repo Prompt provides clarity around your specific code structure. For researchers and academics, it helps manage research papers and datasets. For writers, it organizes reference materials and document collections. For students, it simplifies interactions with AI for assignments and projects.</p>
      
      <p>Repo Prompt isn't here to replace your existing tools. Instead, it's a focused bridge connecting your files directly to AI assistants, making your interactions clearer, more relevant, and ultimately more productive.</p>
    </>
  );
}

export default WhatIsRepoPromptContent;